import React from 'react'
import {SortableContainer, SortableElement} from 'react-sortable-hoc'
import {connect} from 'react-redux'
import arrayMove from 'array-move'
import {Button, List} from 'semantic-ui-react'
import {createAPIClient} from '../../../../../services/api'
import {getTemplatesAction} from '../../../../../actions/template.action'

const SortableItem = SortableElement(({ value }) => {
  return (
    <List.Item>
      <List.Content>
        <List.Header as='a'>{value}</List.Header>
      </List.Content>
    </List.Item>
  )
})

const SortableList = SortableContainer(({items}) => {
  return (
    <List divided verticalAlign='middle'>
      {items.map((value, index) => (
        <SortableItem key={`item-${value.name}`} index={index} value={value.name} />
      ))}
    </List>
  )
})

class TemplateSort extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      templates: this.props.templates || []
      // items: ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6']
    }
  }
  onSortEnd ({oldIndex, newIndex}) {
    this.setState(({templates}) => ({
      templates: arrayMove(templates, oldIndex, newIndex)
    }))
  }
  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.templates !== prevProps.templates) {
      this.setState({
        templates: this.props.templates
      })
    }
  }

  saveOrder () {
    const api = createAPIClient()
    let templates = this.state.templates.map((template, index) =>{
      template.view_index = index
      return template
    })
    api
      .put('/api/templates/update-many', {templates: templates})
      .then(results => {
        this.props.getTemplatesAction()
      })
      .catch(err => {
        console.log(err)
      })
  }
  render () {
    return (
      <div>
        <p><strong>Drag and drop list to sort forms</strong></p>
        <SortableList items={this.state.templates} onSortEnd={this.onSortEnd.bind(this)} />
        <Button primary type='button' onClick={this.saveOrder.bind(this)}>Save order</Button>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {templates: state.templates.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(TemplateSort)



// WEBPACK FOOTER //
// ./src/pages/settings/templates/components/templatesort/index.js